import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { emptySortState, ISortState } from "../../../../models/common/ISortState";
import { IGenericImportFinishedData } from "../../../../models/common/IImportGeneric";

interface VlcPortRquestFinishedState {
    loading: boolean;
    data?: IGenericImportFinishedData;
    sort: ISortState;
}
const initialState: VlcPortRquestFinishedState = {
    loading: false,
    sort: emptySortState(),
};

export const VlcPortImportRequestListReducer = createSlice({
    name: "VlcportImportRequestListReducer",
    initialState,
    reducers: {
        setVlcportImportRequestListData: (state, action: PayloadAction<IGenericImportFinishedData>) => {
            state.data = action.payload;
        },
        setVlcportImportRequestListLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        updateSortColumn: (state, action: PayloadAction<ISortState>) => {
            state.sort = action.payload;
        },

        resetVlcportImportRequestList: () => initialState,
    },
});

export const { resetVlcportImportRequestList, updateSortColumn, setVlcportImportRequestListData, setVlcportImportRequestListLoading } =
    VlcPortImportRequestListReducer.actions;

export default VlcPortImportRequestListReducer.reducer;
